import { addDays, format } from "date-fns";
import { fr } from "date-fns/locale";
import { useCallback, useMemo, useState } from "react";
import { toast } from "sonner";
import { submitRequest } from "../lib/api";

const getVisitErrorInfo = (detail) => {
  const error = Array.isArray(detail) ? detail[0] : null;
  const field = error?.loc?.at(-1);
  if (field === "email") return { field, message: "Saisissez une adresse e-mail valide." };
  if (field === "phone") return { field, message: "Saisissez un numéro de téléphone valide." };
  if (field === "preferred_date") return { field, message: "Choisissez une date de visite valide." };
  if (field === "property_id") return { field, message: "Ce bien n'est plus disponible." };
  return { field: "", message: typeof detail === "string" ? detail : "Vérifiez les informations saisies et réessayez." };
};

const buildVisitDates = (todayKey) => {
  const referenceDate = new Date(todayKey);
  return Array.from({ length: 14 }, (_, index) => {
    const value = addDays(referenceDate, index + 1);
    return {
      value: format(value, "yyyy-MM-dd"),
      label: format(value, "EEEE d MMMM", { locale: fr }),
    };
  });
};

export function useVisitRequest(propertyId) {
  const [date, setDate] = useState("");
  const [visitError, setVisitError] = useState("");
  const [visitErrorField, setVisitErrorField] = useState("");
  const [visitSuccess, setVisitSuccess] = useState("");
  const todayKey = new Date().toDateString();
  const visitDates = useMemo(() => buildVisitDates(todayKey), [todayKey]);
  const updateDate = useCallback((value) => {
    setDate(value);
    if (visitErrorField === "preferred_date") {
      setVisitError("");
      setVisitErrorField("");
    }
  }, [visitErrorField]);

  const submitVisitRequest = useCallback(async (event) => {
    event.preventDefault();
    const formElement = event.currentTarget;
    const form = new FormData(formElement);
    if (!date) {
      setVisitError("Choisissez le créneau souhaité pour votre visite.");
      setVisitErrorField("preferred_date");
      return;
    }
    try {
      setVisitError("");
      setVisitErrorField("");
      setVisitSuccess("");
      const response = await submitRequest("/visits", {
        property_id: propertyId,
        name: form.get("name"),
        email: form.get("email"),
        phone: form.get("phone"),
        preferred_date: date,
        message: form.get("message"),
      });
      toast.success("Votre demande de visite est envoyée.");
      formElement.reset();
      setDate("");
      setVisitSuccess(response.message);
    } catch (error) {
      const errorInfo = getVisitErrorInfo(error.response?.data?.detail);
      setVisitError(errorInfo.message);
      setVisitErrorField(errorInfo.field);
    }
  }, [date, propertyId]);

  return {
    date,
    setDate: updateDate,
    submitVisitRequest,
    visitDates,
    visitError,
    visitErrorField,
    visitSuccess,
  };
}